module.exports = __webpack_public_path__ + "img/nick.055307f1.png";